export default "__VITE_ASSET__Bvid9RMX__"